var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-cropper",class:{
   'image-cropper--moving': _vm.moving,
  }},[_c('img',{ref:"image",staticClass:"image-cropper_img",attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }